import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.authService.isAuthenticated$.pipe(
            tap(loggedIn => {
                // Not logged in > Reject
                if (!loggedIn) {
                    return this.router.navigate(['/login'], { queryParams: { redirect: `${location.pathname}${location.search}${location.hash}` } });
                }
                return true;
            })
        );
    }
}
